module.exports = __webpack_public_path__ + "static/media/3DCBA151-367F-4494-9516-2FB5ABF538E1.d67eb3f6.jpeg";